import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=b7350b3a"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"
import style0 from "./Summary.vue?vue&type=style&index=0&id=b7350b3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports